module.exports = __webpack_public_path__ + "static/media/pizza2.dbd99430.png";